import React from 'react'
import './student-onboarding-template-workflows-card-modal.css'
import axios from 'axios'
import { baseUrl } from '../../assets/Animations'
import { taskCardAnimateIn, taskCardAnimateOut, freshSubtask } from '../../AdminTasks/adminTaskUtils'
import Subtask2023 from '../../TaskCardModal2023/Subtask2023/Subtask2023'

const myToken = localStorage.getItem('token')
const myHeader = {headers: { Authorization: `Bearer ${myToken}` }}

const StudentOnboardingTemplateWorkflowsCardModal = ({workflowTemplateModal2023, setWorkflowTemplateModal2023, editWorkflow, setEditWorkflow}) => {
    React.useEffect(() => taskCardAnimateIn('student-onboarding-template-workflows-modal-2023__wrapper', 'student-onboarding-template-workflows-modal-2023'), [])

    const checkForAutoClear = (val) => {
        val === "Customize Workflow" && setWorkflowTemplateModal2023({...workflowTemplateModal2023, todoName: ''})
    }

    const createAndCloseWorkflowTemplate = () => {
        taskCardAnimateOut('student-onboarding-template-workflows-modal-2023__wrapper', 'student-onboarding-template-workflows-modal-2023')
        axios.post(`${baseUrl}/studentworkflowtemplates`, workflowTemplateModal2023, myHeader)
        .then((res) => {
            setWorkflowTemplateModal2023(false)
        })
        .catch((err) => console.log(err))
    }

    const updateAndCloseWorkflowTemplate = async () => {
        taskCardAnimateOut('student-onboarding-template-workflows-modal-2023__wrapper', 'student-onboarding-template-workflows-modal-2023')
        axios.put(`${baseUrl}/studentworkflowtemplates/${workflowTemplateModal2023.todoId}`, workflowTemplateModal2023, myHeader)
        .then((res) => {
            setEditWorkflow(false)
            setWorkflowTemplateModal2023(false)
        })
        .catch((err) => console.log(err))
    }

    return (
        <div className='student-onboarding-template-workflows-modal-2023__wrapper' id='student-onboarding-template-workflows-modal-2023__wrapper'>
            <div className='student-onboarding-template-workflows-modal-2023' id='student-onboarding-template-workflows-modal-2023'>
                <input className='student-onboarding-template-workflows-modal-2023__task-name' value={workflowTemplateModal2023.todoName} onClick={(e) => checkForAutoClear(e.target.value)} onChange={(e) => setWorkflowTemplateModal2023({...workflowTemplateModal2023, todoName: e.target.value})} />
                {workflowTemplateModal2023.todoSubtasks.map((subtask) => <Subtask2023 key={subtask.subtaskId} subtask={subtask} setOpenModal2023={setWorkflowTemplateModal2023} imEditingATemplate={true} />)}
                <div className='student-onboarding-template-workflows-modal-2023__add-subtask' onClick={() => setWorkflowTemplateModal2023({...workflowTemplateModal2023, todoSubtasks: [...workflowTemplateModal2023.todoSubtasks, freshSubtask()]})}>+ Add Subtask</div>
                <div className='student-onboarding-template-workflows-modal-2023__btn-wrapper'>
                    <div className='student-onboarding-template-workflows-modal-2023__btn__no' onClick={() => setWorkflowTemplateModal2023(false)}>Cancel</div>
                    <div className='student-onboarding-template-workflows-modal-2023__btn__yes' onClick={editWorkflow ? () => updateAndCloseWorkflowTemplate() : () => createAndCloseWorkflowTemplate()}>Save Changes</div>
                </div>
            </div>
        </div>
    )
}
export default StudentOnboardingTemplateWorkflowsCardModal